import { computed, signal } from '@preact/signals-core';
import { Inbox, Shares } from './services/share/ShareService';
import { mergeSignal } from './state_helpers';
import LocalStorage from './store/LocalStorage';
import { Basis, IsacSession, UserData, VirtualFileSystemType } from './types';

export const libraryState = {
  isLoggedIn: signal<boolean>(false),
  session: signal<IsacSession | null>(null),
  token: signal<string | null>(null),
  basis: signal<Basis | null>(null),
  userData: signal<UserData | null>(null),
  shares: signal<Shares | null>(null),
  inbox: signal<Inbox | null>(null),
  cypherCode: signal<string | null>(null),
  virtualFileSystem: signal<VirtualFileSystemType>({
    SecureInBox: {
      files: 0, // Total number of files
      folders: 0, // Total number of folders
      totalSize: 0, // Total size of all files in bytes
      files_list: [],
    },
    SecurePassword: {
      files: 0,
      folders: 0,
      totalSize: 0,
      files_list: [],
    },
    SecureSync: {
      files: 0,
      folders: 0,
      totalSize: 0,
      files_list: [],
    },
    SecureVault: {
      files: 0,
      folders: 0,
      totalSize: 0,
      files_list: [],
    },
  }),
};

export const isAuthenticated = computed(() => libraryState.isLoggedIn.value);

export const getState = () => libraryState;

export const getSession = () => libraryState.session.value;

export const setSession = (session: IsacSession | null) => {
  libraryState.session.value = session;
  libraryState.isLoggedIn.value = !!session;
};

export const getBasis = () => libraryState.basis.value;
export const setBasis = (basis: Basis | null) => {
  libraryState.basis.value = basis;
};

export const getToken = () => libraryState.token.value;
export const setToken = (token: string | null) => {
  libraryState.token.value = token;
};
export const getUserData = () => libraryState.userData.value;
export const setUserData = (userData: Partial<UserData>) => {
  //libraryState.userData.value = userData as UserData
  if (libraryState.userData.value) {
    mergeSignal(libraryState.userData, userData);
  } else {
    libraryState.userData.value = userData as UserData;
  }
};
export const getShares = () => libraryState.shares.value;
export const setShares = (shares: Shares) => {
  libraryState.shares.value = shares;
};
export const getInbox = () => libraryState.inbox.value;
export const setInbox = (inbox: Inbox) => {
  libraryState.inbox.value = inbox;
};

if (typeof window !== 'undefined') {
  const token = LocalStorage.getItem('token');
  if (token) {
    libraryState.token.value = token;
  }
}

export const getStateVirtualFileSystem = () =>
  libraryState.virtualFileSystem.value;
export const setStateVirtualFileSystem = (
  virtualFileSystem: VirtualFileSystemType
) => {
  libraryState.virtualFileSystem.value = virtualFileSystem;
};

export const getCypherCode =
  computed(() => libraryState.cypherCode.value)?.value || '';
export const setCypherCode = (cypherCode: string) => {
  libraryState.cypherCode.value = cypherCode;
};
